import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class UsersDeliverySitesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [
                {
                    "name": "Customer Delivery Site",
                    "location": {
                        "address": "Address",
                        "city": "City",
                        "postal_code": "",
                        "latitude": null,
                        "longitude": null,
                    },
                    "customer": {
                        "business_name": "Business Name"
                    }
                },
                {
                    "name": "Another Customer Delivery Site",
                    "location": {
                        "address": "Another Address",
                        "city": "City",
                        "postal_code": "",
                        "latitude": null,
                        "longitude": null,
                    },
                    "customer": {
                        "business_name": "Another Business Name"
                    }
                },
            ],
            errors: []
        }
    }

    deliverySites() {
        return this.content().map((deliverySite) => this.adaptDeliverySite(deliverySite))
    }

    adaptDeliverySite(deliverySite) {
        return {
            deliverySiteCode: deliverySite.code,
            deliverySiteName: deliverySite.name,
            deliverySiteAddress: deliverySite.location.address,
            deliverySiteCity: deliverySite.location.city,
            deliverySitePostalCode: deliverySite.location.postal_code,
            deliverySiteLatitude: deliverySite.location.latitude,
            deliverySiteLongitude: deliverySite.location.longitude,
            customer: this.adaptCustomer(deliverySite.customer),
        }
    }

    adaptCustomer(customer) {
        return {
            code: customer.code,
            businessName: customer.business_name,
            customerCode: customer.code,
            fantasyName: customer.fantasy_name,
        }
    }
}